export function processUserStatus(user) {
    if (user.account_id) {
        user.selected_account_id = user.account_id;
    }
    else if (user.caregiver_details.length > 0) {
        user.selected_account_id = user.caregiver_details[0].account_id;
        user.selected_owner_name = user.caregiver_details[0].name;
    }
    else {
        user.selected_account_id = null;
    }
    return user;
}
//# sourceMappingURL=processUserStatus.js.map